import React from 'react';
import EmojiPicker, { EmojiPickerPopOver } from '../../components/EmojiPicker';
import OverflowMenu from '../../components/OverflowMenu';

interface CommentMenuProps {
  emojiPickerOpen: boolean;
  onEmojiPickerOpenChange: (open: boolean) => void;
  toggleCommentReaction: (emoji: string) => void;
  menuItems: React.ReactNode;
}

const CommentMenu = ({
  emojiPickerOpen,
  onEmojiPickerOpenChange,
  toggleCommentReaction,
  menuItems,
}: CommentMenuProps) => (
  <>
    <OverflowMenu iconSize="regular">{menuItems}</OverflowMenu>
    <EmojiPickerPopOver
      responsivePlacement
      open={emojiPickerOpen}
      setOpen={onEmojiPickerOpenChange}
    >
      <EmojiPicker
        onPick={(emoji) => {
          onEmojiPickerOpenChange(false);
          toggleCommentReaction(emoji);
        }}
        fullWidth
      />
    </EmojiPickerPopOver>
  </>
);

export default CommentMenu;
